import React from 'react';
import PropTypes from 'prop-types';

import Page from '../common/Page';
import LockScreen from '../verification/LockScreen';

import FAQ from './FAQ';
import FooterStandard from './FooterStandard';
import Hero from './Hero';
import OurTeam from './OurTeam';
import Processes from './Processes';
import Research from './Research';
import Services from './Services';

function Landing({ login, logout, verify }) {
  return (
    <Page unfixed={false} footer={false}>
      <Hero login={login} logout={logout} />
      <LockScreen show={verify} />
      <Processes />
      <Services />
      <FAQ />
      <OurTeam />
      <Research />
      <FooterStandard />
    </Page>
  );
}

Landing.propTypes = {
  login: PropTypes.bool,
  logout: PropTypes.bool,
  verify: PropTypes.bool,
};

Landing.defaultProps = {
  login: false,
  logout: false,
  verify: false,
};

export default Landing;
